module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n    " + _vm._s(_vm.name) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.currentContent.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("No featured content for this section")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.currentContent), function(item) {
    return _c('tr', {
      key: ((item.type) + "_" + (item.id)),
      attrs: {
        "id": ("article" + (item.id))
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.type))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": ("/admin/content/" + (item.type) + "/edit/" + (item.id)),
        "exact": ""
      }
    }, [_vm._v("\n                Edit\n              ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.dettachContent(item)
        }
      }
    }, [_vm._v("\n                Dettach\n                "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item.route
      }
    })], 1)])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Add Url")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newContentUrl),
      expression: "newContentUrl"
    }],
    staticClass: "form-control mb-3",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newContentUrl)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addNewUrl.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newContentUrl = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.newContentUrl) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addNewUrl
    }
  }, [_vm._v("\n              Add\n              "), (_vm.newUrlLoader) ? _c('span', {
    ref: "addUrlLoader",
    staticClass: "btn-loader"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.saveUrlErrorMessage),
      expression: "saveUrlErrorMessage"
    }],
    staticClass: "saving-alerts"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n              " + _vm._s(_vm.saveUrlErrorMessage) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Add Content")]), _vm._v(" "), _c('vue-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.contentTypeOptions
    },
    model: {
      value: (_vm.contentType),
      callback: function($$v) {
        _vm.contentType = $$v
      },
      expression: "contentType"
    }
  }), _vm._v(" "), (_vm.contentType) ? _c('vue-select', {
    ref: "contentEntityModel",
    staticClass: "mb-3",
    attrs: {
      "filterable": false,
      "options": _vm.contentEntityOptions,
      "label": "id"
    },
    on: {
      "search": _vm.onEntitySearch
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_vm._v("\n              " + _vm._s(option.title) + "\n            ")]
      }
    }, {
      key: "selected-option",
      fn: function(option) {
        return [_vm._v("\n              " + _vm._s(option.title) + "\n            ")]
      }
    }], null, false, 1467187853),
    model: {
      value: (_vm.contentEntity),
      callback: function($$v) {
        _vm.contentEntity = $$v
      },
      expression: "contentEntity"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v("\n              type to search...\n            ")])], 2) : _vm._e(), _vm._v(" "), (_vm.contentEntity) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addContent
    }
  }, [_vm._v("\n              Add\n              "), (_vm.newContentLoader) ? _c('span', {
    ref: "addContentLoader",
    staticClass: "btn-loader"
  }) : _vm._e()])]) : _vm._e()], 1)])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Content type")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73fc2caa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/featuredContent/HomeSection.vue
// module id = 942
// module chunks = 0